import "./feedback.scss";
import { HomeProvider } from "../../components/HomePageContext";
import Loading from "../../components/Loading/Loading";
import Header from "../../components/header/Header";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Input from "../../components/input/Input";
import Messages from "../../components/Messages/Messages";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const Feedback = () => {
  const navigate = useNavigate();
  const [chatEnabled, setChatEnabled] = useState(false);

  useEffect(() => {
    try {
      const obf = localStorage.getItem("cf");
      setChatEnabled(obf ? atob(obf) === "ok1" : false);
      if (!obf || atob(obf) !== "ok1") {
        // если чат отключен, редирект сразу
        navigate("/", { replace: true });
      }
    } catch {
      setChatEnabled(false);
      navigate("/", { replace: true });
    }
  }, [navigate]);

  if (!chatEnabled) return null;

  return (
    <div className="feedback">
      <HomeProvider>
        <Loading />
        <Header />

        <div className="feedbackContainer">
          <div className="chatContainer">
            <div className="chatHeader">
              <ArrowBackIcon
                className="arrowIcon"
                onClick={() => navigate("/")}
              />
              <span>Чат с поддержкой</span>
            </div>

            <Messages />
            <Input />
          </div>
        </div>
      </HomeProvider>
    </div>
  );
};

export default Feedback;
